export default "__VITE_ASSET__DAma6yuJ__"